import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import Backend from '@appointment-planner/localization/Backend'

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    load: 'currentOnly', // we don't have a hierarchy in our translations (like both a 'en' and 'en-GB' file)
    fallbackLng: 'en-GB',
    interpolation: {
      escapeValue: false
    },
    react: { useSuspense: true }
  })

export default i18n
